import { CircularProgress } from "@mui/material";
import React from "react";
import { OverlayContainer, Subtitle } from "../../styled/Overlay";

const Overlay = () => {
  return (
    <OverlayContainer>
      <CircularProgress size={200} />
      <Subtitle variant="overline">Cargando...</Subtitle>
    </OverlayContainer>
  );
};

export default Overlay;
